import { AdminUserRoleType } from "../enums/Enums";

export default class AuthAdminUserModel {
    "id": number;
    "name": string;
    "cid": string;
    "company": string;
    "role": string[];
    "comp": string[];
    "ver": string;

    get companies(): string[] {
        if (!this.comp) return [];

        let allCompanies = Array.isArray(this.comp) ? this.comp : [this.comp];
        return allCompanies;
    }

    get canShowAdminScreen(): boolean {
        if (!this.role) return false;
        let allRoles = Array.isArray(this.role) ? this.role : [this.role];
        return allRoles.includes(AdminUserRoleType.Admin) ||
            allRoles.includes(AdminUserRoleType.Billing) ||
            allRoles.includes(AdminUserRoleType.QC) ||
            allRoles.includes(AdminUserRoleType.DataImport) ||
            allRoles.includes(AdminUserRoleType.GroupEmail) ||
            allRoles.includes(AdminUserRoleType.AwardEmail);
    }

    get isAdmin(): boolean {
        let allRoles = Array.isArray(this.role) ? this.role : [this.role];
        return allRoles.includes(AdminUserRoleType.Admin);
    }

    get canDeleteCustomer(): boolean {
        let allRoles = Array.isArray(this.role) ? this.role : [this.role];
        return allRoles.includes(AdminUserRoleType.DeleteCustomer);
    }

    get canDoBilling(): boolean {
        let allRoles = Array.isArray(this.role) ? this.role : [this.role];
        return allRoles.includes(AdminUserRoleType.Admin) || allRoles.includes(AdminUserRoleType.Billing);
    }

    get canDoDataImport(): boolean {
        let allRoles = Array.isArray(this.role) ? this.role : [this.role];
        return allRoles.includes(AdminUserRoleType.Admin) || allRoles.includes(AdminUserRoleType.DataImport);
    }

    get canDoQC(): boolean {
        let allRoles = Array.isArray(this.role) ? this.role : [this.role];
        return allRoles.includes(AdminUserRoleType.Admin) || allRoles.includes(AdminUserRoleType.QC);
    }

    get canDoGroupEmail(): boolean {
        let allRoles = Array.isArray(this.role) ? this.role : [this.role];
        return allRoles.includes(AdminUserRoleType.Admin) || allRoles.includes(AdminUserRoleType.GroupEmail);
    }

    get canDoAwardEmail(): boolean {
        let allRoles = Array.isArray(this.role) ? this.role : [this.role];
        return allRoles.includes(AdminUserRoleType.Admin) || allRoles.includes(AdminUserRoleType.AwardEmail);
    }

    get canEmail(): boolean {
        let allRoles = Array.isArray(this.role) ? this.role : [this.role];
        return allRoles.includes(AdminUserRoleType.Admin) ||
        allRoles.includes(AdminUserRoleType.GroupEmail) ||
        allRoles.includes(AdminUserRoleType.AwardEmail);
    }
}